/**
 * Set cross-browser requestAnimFrame for more performant animating
 *
 * http://www.paulirish.com/2011/requestanimationframe-for-smart-animating/
 */
window.requestAnimFrame = (function () {
	return window.requestAnimationFrame
		|| window.webkitRequestAnimationFrame
		|| window.mozRequestAnimationFrame
		|| function (callback) {
			window.setTimeout(callback, 1000 / 60);
		};
})();



// detect touch devices (global variable)
var isTouchDevice = 'ontouchstart' in document.documentElement || 'ontouchstart' in window || navigator.msMaxTouchPoints;

var isCSSTransitionSupported = function() {
	var b = document.body || document.documentElement,
		s = b.style,
		p = 'transition';

	if (typeof s[p] == 'string') { return true; }

	// Tests for vendor specific prop
	var v = ['Moz', 'webkit', 'Webkit', 'Khtml', 'O', 'ms'];
	p = p.charAt(0).toUpperCase() + p.substr(1);

	for (var i=0; i<v.length; i++) {
		if (typeof s[v[i] + p] == 'string') { return true; }
	}

	return false;
};

var matches = function(ele, selector) {
	return (
		ele.matches ||
		ele.matchesSelector ||
		ele.msMatchesSelector ||
		ele.mozMatchesSelector ||
		ele.webkitMatchesSelector ||
		ele.oMatchesSelector
	).call(ele, selector);
};

// Find the closest element to `ele` and matches the `selector`
var closest = function(ele, selector) {
	var e = ele;
	while (e) {
		if (matches(e, selector)) {
			break;
		}
		e = e.parentNode;
	}
	return e;
};
